import { observer, useLocalObservable } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import { httpClient } from 'domain/utils/httpClient';
import swal from 'sweetalert2';
import q from 'q'
import { dateFormat } from '../../lib/helpers';
import {
    TextField,
    FormControlLabel,
    Checkbox,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Select,
    SelectChangeEvent,
    MenuItem,
    InputLabel,
    FormControl
} from '@mui/material';
import { action, computed, observable, makeObservable, makeAutoObservable } from 'mobx';

type StatusValues = "Initial" | "Verified" | "Confirmed";

class DialogState {
    isOpened: boolean = false;
    registrationId: number | null = null;
    username: string | null = null;
    email: string | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    whatsapp: string | null = null;
    mobile: string | null = null;
    password: string | null = null;
    sendEmail: boolean = true;
    preferredTime: string | null = null;
    course: number | undefined = undefined;

    constructor() {
        makeAutoObservable(this)
    }

    setOpened(row: GetListResponse_Item, password: string) {
        this.registrationId = row.Id;
        this.email = row.Email;
        this.username = row.Email;
        this.firstName = row.FullName;
        this.lastName = row.FullName;
        this.whatsapp = row.Whatsapp;
        this.preferredTime = row.PreferredTime;
        this.course = row.Course;
        this.password = password;
        this.sendEmail = true;
        this.mobile = null;

        this.isOpened = true;
    }

    setClosed() {
        this.isOpened = false;
    }

    setRegistrationId(registrationId: number | null) {
        this.registrationId = registrationId;
    }

    setUsername(username: string | null) {
        this.username = username;
    }

    setEmail(email: string | null) {
        this.email = email;
    }

    setFirstName(name: string | null) {
        this.firstName = name;
    }

    setLastName(name: string | null) {
        this.lastName = name;
    }

    setWhatsApp(value: string | null) {
        this.whatsapp = value;
    }

    setMobile(value: string | null) {
        this.mobile = value;
    }

    setPassword(value: string | null) {
        this.password = value;
    }

    setSendEmail(value: boolean) {
        this.sendEmail = value;
    }

    setPreferredTime(value: string | null) {
        this.preferredTime = value;
    }

    setCourse(value: number | undefined) {
        this.course = value;
    }
}

const dialogState = new DialogState();

interface GetListResponse {
    Items: GetListResponse_Item[];
}

interface GetListResponse_Item {
    Id: number;
    CreatedAt: number;
    FullName: string;
    Email: string;
    Status: StatusValues;
    Whatsapp: string;
    PreferredTime: string;
    Course: number;
}

interface ConfirmRequest {
    RegistrationId: number | null;
    Username: string | null;
    Email: string | null;
    FirstName: string | null;
    LastName: string | null;
    Mobile: string | null;
    Password: string | null;
    SendEmail: boolean;
    Course: number | undefined;
}

interface ConfirmDialogProps {
    updateStatus: (registrationId: number, newStatus: StatusValues) => void;
}

function ConfirmDialogComponent(props: ConfirmDialogProps) {

    const handleClose = () => {
        dialogState.setClosed();
    };

    const handleSubmit = async () => {
        const url = "/api/registration/confirm";
        const data: ConfirmRequest = {
            RegistrationId: dialogState.registrationId,
            Email: dialogState.email,
            FirstName: dialogState.firstName,
            LastName: dialogState.lastName,
            Mobile: dialogState.mobile,
            Password: dialogState.password,
            Username: dialogState.username,
            SendEmail: dialogState.sendEmail,
            Course: dialogState.course,
        };
        await httpClient.axios.postWithSweetAlert(url, data);
        swal.close();
        await swal.fire({ icon: "success", text: "Confirm success" });
        props.updateStatus(dialogState.registrationId!, "Confirmed");
        dialogState.setClosed();
    };

    return (
        <React.Fragment>
            <Dialog
                open={dialogState.isOpened}
                onClose={handleClose}
            >
                <DialogTitle>CONFIRM REGISTRATION. CREATE NEW USER - STUDENT</DialogTitle>
                <DialogContent>
                    <TextField
                        id="outlined-basic1"
                        margin="dense"
                        fullWidth
                        label="First Name"
                        variant="outlined"
                        required
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setFirstName(event.target.value)
                        }}
                        defaultValue={dialogState.firstName}
                    />
                    <TextField
                        id="outlined-basic1"
                        margin="dense"
                        fullWidth
                        label="Last Name"
                        variant="outlined"
                        required
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setLastName(event.target.value)
                        }}
                        defaultValue={dialogState.lastName}
                    />
                    <FormControl sx={{ minWidth: 200 }} size="small" margin="dense" fullWidth>
                        <InputLabel id="demo-select-small-label">Course</InputLabel>
                        <Select
                            labelId="demo-select-small-label"
                            id="demo-select-small"
                            value={dialogState.course}
                            label="Course"
                            margin="dense"
                            fullWidth
                            onChange={(event: SelectChangeEvent<number>) => {
                                dialogState.setCourse(event.target.value as number);
                            }}
                        >
                            <MenuItem value={1}>Английский для взрослых</MenuItem>
                            <MenuItem value={2}>Английский для детей</MenuItem>
                            <MenuItem value={3}>Английский для школьников</MenuItem>
                        </Select>
                    </FormControl>

                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="Username"
                        variant="outlined"
                        required
                        defaultValue={dialogState.username}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setUsername(event.target.value)
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="Email"
                        variant="outlined"
                        required
                        defaultValue={dialogState.email}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setEmail(event.target.value)
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="Mobile"
                        variant="outlined"
                        required
                        defaultValue={dialogState.mobile}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setMobile(event.target.value)
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="WhatsApp/Telegram/Other"
                        variant="outlined"
                        required
                        defaultValue={dialogState.whatsapp}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setWhatsApp(event.target.value)
                        }}
                    />
                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="Preferred Time"
                        variant="outlined"
                        required
                        InputProps={{
                            readOnly: true,
                        }}
                        defaultValue={dialogState.preferredTime}
                    />
                    <TextField
                        id="outlined-basic"
                        margin="dense"
                        fullWidth
                        label="Password"
                        variant="outlined"
                        required
                        defaultValue={dialogState.password}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            dialogState.setPassword(event.target.value)
                        }}
                    />
                    <FormControlLabel
                        control={<Checkbox checked={dialogState.sendEmail}
                            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                dialogState.setSendEmail(event.target.checked)
                            }} />}
                        label="Send instruction with login information by email"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit" onClick={handleSubmit}>Create new user - Student</Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}

const ConfirmDialog = observer(ConfirmDialogComponent);

function RegistrationListComponent() {
    const [rows, setRows] = useState<GetListResponse_Item[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            const url = `/api/registration/list`;
            const result = await httpClient.axios.getWithSweetAlert<GetListResponse>(url);
            setRows(result.data.Items);
            swal.close();
        }

        fetchData()
            // make sure to catch any error
            .catch(console.error);
    }, []);

    async function openDialog(row: GetListResponse_Item) {
        const url = `/api/registration/generate-password`;
        const result = await httpClient.axios.getWithSweetAlert<string>(url);
        const password = result.data;
        swal.close();
        dialogState.setOpened(row, password);
    }

    const updateStatusFn = (registrationId: number, newStatus: StatusValues) => {
        const newRows = rows.map(row => {
            if (row.Id == registrationId) {
                row.Status = newStatus;
            }
            return row;
        });
        setRows(newRows);
    }

    return (
        <div>
            <ConfirmDialog updateStatus={updateStatusFn} />
            <h3>Registrations - Last 100</h3>
            <table className="table">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Date</th>
                        <th scope="col">Status</th>
                        <th scope="col">Full Name</th>
                        <th scope="col">Email</th>
                        <th scope="col">WhatsApp/Telegram/Other</th>
                        <th scope="col">Preferred Time</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rows.map(row => (
                            <tr key={row.Id}>
                                <th scope="row">{row.Id}</th>
                                <th scope="row">{dateFormat(row.CreatedAt, 'wymdhm', true)}</th>
                                <td>{row.Status}</td>
                                <td>{row.FullName}</td>
                                <td>{row.Email}</td>
                                <td>{row.Whatsapp}</td>
                                <td>{row.PreferredTime}</td>
                                <td>
                                    {row.Status == 'Verified' &&
                                        <button type="button" className="btn btn-primary" onClick={() => { openDialog(row) }}>
                                            Confirm
                                        </button>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
        </div>
    );
}

export default observer(RegistrationListComponent);
